<div class="app-body">
  <div class="row">
    <div class="col-xxl-12">
      <div class="card" style="margin-left: 1px">
        <div class="card-body">
          <div class="custom-tabs-container">
            <ul class="nav nav-tabs justify-content-end" id="customTab5" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link active" id="tab-BienBanATTP" data-bs-toggle="tab" href="#BienBanATTP" role="tab"
                  aria-controls="BienBanATTP" aria-selected="true">
                  <span class="badge bg-info" style="font-size: 16px">Biên bản Thẩm định ATTP</span>
                </a>
              </li>
            </ul>
            <div class="tab-content" id="customTabContent">
              <div class="tab-pane fade show active" id="BienBanATTP" role="tabpanel">
                <div class="row gx-4">
                  <div class="col-lg-4 col-sm-12 col-12">
                    <label *ngIf="!NotificationService.IsMobile" class="form-label">Phân loại</label>
                    <select class="form-select" [(ngModel)]="BienBanATTPService.BaseParameter.ParentID">
                      <option *ngFor="let item of DanhMucProductGroupService.List;" [value]="item.ID">
                        {{item.Name}}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-sm-12 col-12">
                    <label *ngIf="!NotificationService.IsMobile" class="form-label">.</label>
                    <input [(ngModel)]="BienBanATTPService.BaseParameter.SearchString" placeholder="Tìm ..."
                      class="form-control" (keyup.enter)="BienBanATTPSearch()" />
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <label *ngIf="!NotificationService.IsMobile" class="form-label">.</label>
                    <div class="row gx-4">
                      <div class="col-lg-6 col-sm-6 col-6">
                        <a style="width: 100%;" class="btn btn-success" title="Tìm" (click)="BienBanATTPSearch()"><i
                            class="bi bi-search"></i></a>
                      </div>
                      <div class="col-lg-6 col-sm-6 col-6">
                        <a style="width: 100%;" class="btn btn-success" title="Thêm mới" (click)="BienBanATTPAdd(0)"><i
                            class="bi bi-plus"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card mb-4 card-info">
                  <div class="card-header">
                    <h5 class="card-title text-white">
                      Danh sách
                      <span *ngIf="BienBanATTPService.List">({{ BienBanATTPService.List.length }} items)</span>
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="table-outer">
                      <div class="table-responsive">
                        <table *ngIf="!NotificationService.IsMobile" mat-table matSort #BienBanATTPSort="matSort"
                          [dataSource]="BienBanATTPService.DataSource" class="table table-striped m-0">
                          <ng-container matColumnDef="STT">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                              STT
                            </th>
                            <td mat-cell *matCellDef="let element; index as i" style="text-align: center">
                              <div *ngIf="BienBanATTPPaginator">
                                {{
                                BienBanATTPPaginator.pageSize *
                                BienBanATTPPaginator.pageIndex +
                                i +
                                1
                                }}
                              </div>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="ID">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                              ID
                            </th>
                            <td mat-cell *matCellDef="let element">
                              {{ element.ID }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="Name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                              Ðiều Khoản Tham Chiếu
                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 400px; white-space: normal;">
                              <a style="cursor: pointer; white-space: normal;" title="{{element.Name}}"
                                class="link-primary" (click)="BienBanATTPAdd(element.ID)"><b>{{element.Name}}</b></a>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="Description">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                              Nhóm Chỉ Tiêu Đánh Giá
                            </th>
                            <td mat-cell *matCellDef="let element" style="white-space: normal;">
                              {{element.Description}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="SortOrder">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                              Sắp xếp
                            </th>
                            <td mat-cell *matCellDef="let element">
                              {{element.SortOrder}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="Save">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let element">
                              <a class="btn btn-danger" (click)="BienBanATTPDelete(element)" *ngIf="element.ID > 0"><i
                                  class="bi bi-trash"></i>
                              </a>
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="BienBanATTPService.DisplayColumns001"></tr>
                          <tr mat-row *matRowDef="
                              let row;
                              columns: BienBanATTPService.DisplayColumns001
                            "></tr>
                        </table>
                        <mat-paginator *ngIf="!NotificationService.IsMobile" #BienBanATTPPaginator="matPaginator"
                          [pageSizeOptions]="[10, 20, 50, 100, 500, 999]" [pageSize]="100" [showFirstLastButtons]></mat-paginator>

                        <table *ngIf="NotificationService.IsMobile" mat-table matSort #BienBanATTPSort="matSort"
                          [dataSource]="BienBanATTPService.DataSource" class="table table-striped m-0">
                          <ng-container matColumnDef="STT">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                              Danh sách
                            </th>
                            <td mat-cell *matCellDef="let element; index as i">
                              <div class="row gx-4">
                                <div class="col-lg-12 col-sm-12 col-12">
                                  <label class="form-label">Ðiều Khoản Tham Chiếu</label>
                                  <a style="cursor: pointer" title="{{element.Name}}" class="link-primary"
                                    (click)="BienBanATTPAdd(element.ID)"><b>{{element.Name}}</b></a>
                                </div>
                                <div class="col-lg-12 col-sm-12 col-12">
                                  <label class="form-label">Nhóm Chỉ Tiêu Đánh Giá</label>
                                  {{element.Description}}
                                </div>
                                <div class="row gx-4">
                                  <div class="col-lg-12 col-sm-12 col-12">
                                    <a class="btn btn-danger" style="width: 100%" (click)="BienBanATTPDelete(element)"
                                      *ngIf="element.ID > 0"><i class="bi bi-trash"></i>
                                    </a>
                                  </div>
                                  <br />
                                  <br />
                                </div>
                              </div>
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="
                              BienBanATTPService.DisplayColumnsMobile
                            "></tr>
                          <tr mat-row *matRowDef="
                              let row;
                              columns: BienBanATTPService.DisplayColumnsMobile
                            "></tr>
                        </table>
                        <mat-paginator *ngIf="NotificationService.IsMobile" #BienBanATTPPaginator="matPaginator"
                          [pageSizeOptions]="[10, 20, 50, 100, 500, 999]" [pageSize]="10000"
                          [showFirstLastButtons]></mat-paginator>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading *ngIf="BienBanATTPService.IsShowLoading"></app-loading>